export const normalizeFilename = (value) => {
  let normalizedValue = (value || '').toLowerCase().normalize('NFD').replace(/[^\w\s-.,]/g, '').replace(/[,.\s]+/g, '-');
  // remove double dash
  while (normalizedValue.match(/.*[-][-].*/g)) {
    normalizedValue = normalizedValue.replace(/[-][-]/g, '-');
  }
  return normalizedValue;
};

export const normalize = (value) => {
  return (value || '').toLowerCase().normalize('NFD').replace(/[^\w]/g, '');
};



// WEBPACK FOOTER //
// ./client/utils.js